import { LoadingButton } from "@mui/lab";
import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { MutasiValues, SelectedProductMutasi } from "../../../constants/types";
import { useAuth } from "../../../context/authContext";
import { useMutasiStokModal } from "../../../context/mutasiStokModalContext";
import BarangTerpilih from "../BarangTerpilih/BarangTerpilih";

// registerLocale("id", id);
// setDefaultLocale("id");

interface IDetailItemMutasiStepProps {
    products: SelectedProductMutasi[];
    onBack: () => void;
}

const DetailItemMutasiStep = ({
    products,
    onBack,
}: IDetailItemMutasiStepProps) => {
    const today = new Date();
    const now = today.toLocaleString("id", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
    const { ukmIdUser } = useAuth();
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const { isOpenModalMutasiStok } = useMutasiStokModal();
    // const [startDate, setStartDate] = useState<Date | null>(new Date());

    const initialValues: MutasiValues = useMemo(
        () => ({
            ukmId: ukmIdUser && ukmIdUser[0],
            detail: products.map((li) => ({
                itemId: li.id,
                jumlahStok: "",
                keterangan: "",
                isMasuk: "masuk",
                stokRepack: "",
                itemRepack: null,
                hargaBeliRepack: null,
            })),
        }),
        [products, ukmIdUser],
    );

    const methods = useForm<MutasiValues>({
        // resolver: yupResolver(schema),
        defaultValues: initialValues,
    });
    const { fields } = useFieldArray({
        control: methods.control,
        name: `detail`,
    });

    const onSubmit = async (values: MutasiValues) => {
        setIsButtonLoading(true);
        try {
            const body = {
                ukmId: values.ukmId,
                detail: values.detail.map((li) => ({
                    tipe: li.isMasuk === "repack" ? "repack" : undefined,
                    itemIdAwal: li.isMasuk === "repack" ? li.itemId : undefined,
                    itemIdFaktur:
                        li.isMasuk === "repack" ? li.faktur?.id : undefined,
                    jumlahKeluar:
                        li.isMasuk === "repack"
                            ? Number(li.jumlahStok)
                            : li.isMasuk === "keluar"
                              ? Number(li.jumlahStok)
                              : 0,
                    itemIdTujuan:
                        li.isMasuk === "repack" ? li.itemRepack?.id : undefined,
                    jumlahMasuk:
                        li.isMasuk === "repack"
                            ? Number(li.stokRepack)
                            : li.isMasuk === "masuk"
                              ? Number(li.jumlahStok)
                              : 0,
                    hargaBeli:
                        li.isMasuk === "repack"
                            ? String(li.hargaBeliRepack).replace(/\./g, "")
                            : li.faktur?.hargaBeli,
                    kodeFaktur: li.isMasuk === "repack" ? null : undefined,
                    itemId: li.isMasuk === "repack" ? undefined : li.itemId,
                    keterangan: li.keterangan,
                    fakturId:
                        li.isMasuk === "repack" ? undefined : li.faktur?.id,
                })),
            };
            console.log(body);
            // const { data } = await axios.post<AddMutasiResponse>(
            //     `/api/mutasiitem`,
            //     body,
            // );
            // if (data.code === 200) {
            //     Swal.fire({
            //         title: "Stok telah dimutasi",
            //         position: "top-end",
            //         showConfirmButton: false,
            //         icon: "success",
            //         toast: true,
            //         timer: 3000,
            //         timerProgressBar: true,
            //         showCloseButton: true,
            //         customClass: {
            //             container: "my-swal",
            //         },
            //     });
            //     setFetchingItems();
            //     closeModalMutasiStok();
            // }
            setIsButtonLoading(false);
        } catch (error) {
            setIsButtonLoading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        if (isOpenModalMutasiStok) {
            methods.reset(initialValues);
        }
    }, [initialValues, isOpenModalMutasiStok, methods]);

    return (
        <React.Fragment>
            <Typography fontWeight="bold" component="div">
                Tanggal:{" "}
                <Typography display="inline" color="GrayText">
                    {now}
                </Typography>
            </Typography>
            <Stack mt={2} mb={5} direction="column" spacing={2}>
                {fields.map((li, idx) => (
                    <BarangTerpilih
                        key={li.id}
                        idx={idx}
                        methods={methods}
                        product={products[idx]}
                    />
                ))}
            </Stack>
            <Box
                mt={4}
                display="grid"
                gridTemplateColumns="1fr 1fr 1fr"
                justifyContent="flex-end"
                columnGap="16px"
            >
                <div />
                <Button onClick={onBack} variant="outlined">
                    Kembali
                </Button>
                <LoadingButton
                    loading={isButtonLoading}
                    loadingPosition="center"
                    variant="contained"
                    onClick={methods.handleSubmit(onSubmit)}
                >
                    Simpan
                </LoadingButton>
            </Box>
        </React.Fragment>
    );
};

export default DetailItemMutasiStep;
